import template from './imgCarousel.html';

let component  = {
	bindings: {
		images: "=",
		alatest: "=",
		thumbSize: "@"
	},
	template,
	controller: function() {
		"ngInject";

		var vm = this;

		if (vm.images && vm.images.length > 0) {
			vm.activeImage = vm.images[0].id;
			vm.currentItem = (vm.images.length == 1)?0:1;
		}

		vm.nextImage = function(index) {
			if (vm.images[index+1]) {
				vm.activeImage = vm.images[index+1].id;
			} else {
				vm.activeImage = vm.images[0].id;
			}
		}

		vm.setNewVal = function(direction, allow){
			if(allow) {
				if (direction){
					vm.currentItem++;
				} else{
					vm.currentItem--;
				}
			}
		}
	}
};

export default component;


// WEBPACK FOOTER //
// ./app/components/imgCarousel/imgCarousel.component.js